import styled from 'astroturf/react';
import { Link } from 'react-router-dom';

const Tabs = styled('div')`
  display: flex;
  flex-direction: row;
`;

const Tab = styled(Link)`
  transition: var(--ph-button-transition);
  font-family: var(--ph-font-family-franklin-medium-regular);
  background-color: var(--transparent);
  color: var(--ph-gray-500);
  border-radius: var(--ph-border-radius-sm);
  display: inline-flex;
  appearance: none;
  align-items: center;
  justify-content: center;
  user-select: none;
  touch-action: manipulation;
  text-transform: none;
  position: relative;
  white-space: nowrap;
  vertical-align: middle;
  line-height: 1.2;
  outline: none;
  font-size: var(--ph-text-sm);
  padding-left: 12px;
  padding-right: 12px;
  height: 32px;
  min-width: 32px;
  border: 0;
  cursor: pointer;

  &:hover {
    background-color: var(--ph-gray-25);
    color: var(--ph-gray-700);
  }

  &:active {
    background-color: var(--ph-gray-50);
    color: var(--ph-gray-700);
  }

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
  }

`;

const TabNoLink = styled('span')`
  transition: var(--ph-button-transition);
  font-family: var(--ph-font-family-franklin-medium-regular);
  background-color: var(--transparent);
  color: var(--ph-gray-500);
  border-radius: var(--ph-border-radius-sm);
  display: inline-flex;
  appearance: none;
  align-items: center;
  justify-content: center;
  user-select: none;
  touch-action: manipulation;
  text-transform: none;
  position: relative;
  white-space: nowrap;
  vertical-align: middle;
  line-height: 1.2;
  outline: none;
  font-size: var(--ph-text-sm);
  padding-left: 12px;
  padding-right: 12px;
  height: 32px;
  min-width: 32px;
  border: 0;
  cursor: pointer;

  &:hover {
    background-color: var(--ph-gray-25);
    color: var(--ph-gray-700);
  }

  &:active {
    background-color: var(--ph-gray-50);
    color: var(--ph-gray-700);
  }

  &:focus {
    box-shadow: var(--ph-box-shadow-focus);
  }
`;

export default {
  Tabs,
  Tab,
  TabNoLink,
};
